import shave from 'shave';
import Blue from "~/core";

new Blue({
	name: 'Truncate',
	selector: ".text-truncate",
	setup(truncate) {
        const maxheight = 50
        shave(truncate, maxheight);
	}
});